// The section keys of the hub (R3268, ui-map-interface.md §16.3): a bare
// digit opens the section of its place in the dock and the strip, in the
// order of `TAB_KEYS`: 1 PLAY to 9 HELP, and 0 SETTINGS. The keys are the
// rows `section` and `section_ten` of `[keys.hub]`. A digit typed in a
// text field stays a digit, so the shell takes no key while the focus is
// in one.

import { KEYS } from '../../gen/presentation';
import { type KeyPress, digitOf, matchKey } from '../../keys';
import { TAB_KEYS, type TabKey } from './panel';

/** The two rows of `[keys.hub]` that open a section. */
const SECTION_KEYS = { section: KEYS.hub.section, section_ten: KEYS.hub.section_ten };

/** Is the target a place where a key types text: a text field, a select
 *  or an editable element? */
export function typesText(t: EventTarget | null): boolean {
  if (!(t instanceof HTMLElement)) return false;
  return t.isContentEditable || t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.tagName === 'SELECT';
}

/** The section a press opens, or null: a press that is no section key,
 *  or a press whose target types text. */
export function sectionOfKey(e: KeyPress & { target: EventTarget | null }): TabKey | null {
  if (typesText(e.target) || matchKey(e, SECTION_KEYS) === null) return null;
  const d = digitOf(e);
  return TAB_KEYS[d === 0 ? 9 : d - 1] ?? null;
}
